export default __webpack_public_path__ + "img/volume.1d72f342.svg";